import { derived, get } from "svelte/store";
import { calcDistance, playerPosition } from "../Services/geolocation";
import { State } from "./State";
export class Checkpoint {
    constructor(id, name, description, clue, lookAtPlayer, accesibility, activities, inventory, isCompleted, onCompleted, position, marker) {
        this.id = id;
        this.name = name;
        this.description = description;
        this.clue = clue;
        this.lookAtPlayer = lookAtPlayer;
        this.accesibility = accesibility;
        this.activities = activities;
        this.inventory = inventory;
        this.isCompleted = isCompleted;
        this.onCompleted = onCompleted;
        this.position = position;
        this.marker = marker;
        this.lastIsTargetValue = false;
        this.isVisible = new State(false);
        this.isAccesible = new State(false);
        this.isTarget = derived([this.isVisible, this.isAccesible, this.isCompleted], (...[, set]) => {
            const isTarget = this.getIsTarget();
            //Solo emitimos cuando el valor de isTarget ha cambiado
            if (isTarget !== this.lastIsTargetValue) {
                this.lastIsTargetValue = isTarget;
                set(isTarget);
            }
        }, this.lastIsTargetValue);
        this.needGeolocation = this.accesibility.accesibleOn.some(({ distance }) => undefined !== distance);
    }
    getIsTarget() {
        return (this.isVisible.value || this.isAccesible.value) && !this.isCompleted.value;
    }
    setVisible(value) {
        if (value === this.isVisible.value) {
            return;
        }
        this.isVisible.set(value);
    }
    setAccesible(value) {
        if (value === this.isAccesible.value) {
            return;
        }
        this.isAccesible.set(value);
    }
    setCompleted() {
        if (this.isCompleted.value) {
            return;
        }
        this.isCompleted.set(true);
    }
    /**
     * Determina si el usuario está demasiado lejos
     * para interactuar con el checkpoint
     * @returns {boolean}
     */
    isTooFar() {
        if (!this.needGeolocation) {
            return false;
        }
        const distanceStatement = this.accesibility.accesibleOn.find(({ distance }) => undefined !== distance);
        if (!distanceStatement) {
            return false;
        }
        const playerCoordinates = get(playerPosition);
        if (!playerCoordinates) {
            return true;
        }
        return calcDistance(playerCoordinates, this.position) > distanceStatement.distance;
    }
    playerCanInteract() {
        const { isAccesible, isVisible } = this;
        return isVisible.value && isAccesible.value;
    }
    allActivitiesAreCompleted() {
        const activityNames = [
            'chat',
            'info',
            'secret',
            'gallery',
            'image360',
        ];
        return activityNames.every(activityName => {
            var _a, _b;
            return (_b = (_a = this.activities[activityName]) === null || _a === void 0 ? void 0 : _a.isCompleted.value) !== null && _b !== void 0 ? _b : true;
        });
    }
}
